var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRulerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81741 10.6068L2.48405 10.6067L2.48404 5.39245L13.5674 5.39244L13.5674 10.6068L11.8174 10.6068L11.8174 8.44011L10.6507 8.4401L10.6507 10.6068L8.90074 10.6068L8.90073 7.2411L7.73408 7.2411L7.73406 10.6068L5.98407 10.6068L5.98407 8.44011L4.81742 8.44011L4.81741 10.6068ZM14.734 11.1901L14.734 4.80911C14.734 4.48696 14.4729 4.22579 14.1507 4.22578L1.90072 4.22579C1.57856 4.2258 1.31739 4.48697 1.31738 4.80912L1.31738 11.1901C1.31741 11.5123 1.57855 11.7734 1.90071 11.7734L14.1507 11.7734C14.4729 11.7734 14.7341 11.5123 14.734 11.1901Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerIcon);
export default __webpack_public_path__ + "static/media/RulerIcon.b38a1d9c485d856194cf9f4565720c5e.svg";
export { ForwardRef as ReactComponent };